import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import "@/i18n";
import "@/App.css";

// Lazy-load pages for fast initial paint
const Home = lazy(() => import("@/pages/Home"));
const About = lazy(() => import("@/pages/About"));
const Products = lazy(() => import("@/pages/Products"));
const ProductDetail = lazy(() => import("@/pages/ProductDetail"));
const RoastedGreenTea = lazy(() => import("@/pages/RoastedGreenTea"));
const Industries = lazy(() => import("@/pages/Industries"));
const OEM = lazy(() => import("@/pages/OEM"));
const Sustainability = lazy(() => import("@/pages/Sustainability"));
const QualityControl = lazy(() => import("@/pages/QualityControl"));
const ExportProcess = lazy(() => import("@/pages/ExportProcess"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const Resources = lazy(() => import("@/pages/Resources"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Contact = lazy(() => import("@/pages/Contact"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const LoadingFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="font-serif italic text-2xl text-muted-foreground animate-pulse">Loading…</div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <Layout>
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/roasted-green-tea" element={<RoastedGreenTea />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/oem" element={<OEM />} />
                <Route path="/sustainability" element={<Sustainability />} />
                <Route path="/quality" element={<QualityControl />} />
                <Route path="/export-process" element={<ExportProcess />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </Layout>
          <Toaster position="bottom-center" richColors closeButton />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
